/**
 * Report reasons for the report modal
 */
export const REPORT_REASONS = [
  { value: 'inappropriate', label: 'Inappropriate Content' },
  { value: 'harassment', label: 'Harassment' },
  { value: 'spam', label: 'Spam' },
  { value: 'other', label: 'Other' }
] as const;

export type ReportReason = typeof REPORT_REASONS[number]['value'];

/**
 * Default ICE server configuration
 */
export const DEFAULT_ICE_CONFIG = {
  iceCandidatePoolSize: 10,
  iceTransportPolicy: 'all' as RTCIceTransportPolicy,
  bundlePolicy: 'max-bundle' as RTCBundlePolicy,
  rtcpMuxPolicy: 'require' as RTCRtcpMuxPolicy
} as const;

/**
 * Connection status display messages
 * Maps connection state to user-friendly status text
 */
export const CONNECTION_STATUS = {
  online: 'Online',
  disconnected: 'Disconnected',
  connecting: 'Connecting...'
} as const;